import React from "react";
import PropTypes from "prop-types";

import styles from "./DropdownIcon.css";

const DropdownIcon = ({ icon, onClick }) => {
  const Icon = icon;

  return (
    <div className={styles.root} onClick={onClick}>
      <div className={styles.ieMask} />
      <Icon />
    </div>
  );
};

DropdownIcon.propTypes = {
  icon: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default DropdownIcon;
